module.exports = __webpack_public_path__ + "img/theme_bright_round.842ee7.svg";